export default {
  init() {
    const backToTopButton = document.querySelector('.back-to-top-button');

    // Function to scroll to the top of the page
    function scrollToTop() {
      window.scrollTo({ top: 0 });
    }

    // Event listener for the button click
    backToTopButton.addEventListener('click', scrollToTop);

    // Event listener for the "Enter" key press while the button is focused
    backToTopButton.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        scrollToTop();
      }
    });
  },
};
